import { CRM_LEAD_VK_META_EMPTY } from '@/api/types/crm/crmLeadFunnels.types'
import type { CrmChatProviderKey } from '@/api/types/crm/crmLeadFunnels.types'
import {
  getLeadProviderChatMeta,
  getLeadVkChatMeta,
  patchLeadProviderChatMeta,
} from '@pages/Admin/CRM/utils/leadFields'
import type { KanbanCard } from '../store/kanban.types'

/** Синхронизация unread VK на карточке канбана (integrations.vkontakte + legacy vk). */
export const buildPatchedKanbanCardVkUnread = (
  card: KanbanCard,
  unreadCount: number,
  updatedAt?: string | null,
): KanbanCard =>
  buildPatchedKanbanCardProviderUnread(
    card,
    'vkontakte',
    unreadCount,
    updatedAt,
  )

/** Unread любого CRM-провайдера на карточке канбана. */
export const buildPatchedKanbanCardProviderUnread = (
  card: KanbanCard,
  provider: CrmChatProviderKey,
  unreadCount: number,
  updatedAt?: string | null,
): KanbanCard => {
  const prevHasChat =
    getLeadProviderChatMeta(card, provider)?.has_chat ??
    (provider === 'vkontakte' ? getLeadVkChatMeta(card)?.has_chat : true) ??
    true
  const patch = {
    has_chat: prevHasChat,
    unread_count: unreadCount,
    ...(updatedAt !== undefined ? { updated_at: updatedAt } : {}),
  }

  const base =
    provider === 'vkontakte'
      ? {
          ...card,
          vk: card.vk ?? CRM_LEAD_VK_META_EMPTY,
        }
      : card

  const nextCard = patchLeadProviderChatMeta(base, provider, patch)

  const nextFunnelListRow = card.funnelListRow
    ? (patchLeadProviderChatMeta(
        card.funnelListRow,
        provider,
        patch,
      ) as typeof card.funnelListRow)
    : card.funnelListRow

  return {
    ...nextCard,
    ...(nextFunnelListRow ? { funnelListRow: nextFunnelListRow } : {}),
  }
}

export const formatVkReadUpdatedAt = (date = new Date()): string => {
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
}
